import { render, staticRenderFns } from "./FormRisk.vue?vue&type=template&id=1c26f8bd&scoped=true&"
import script from "./FormRisk.vue?vue&type=script&lang=js&"
export * from "./FormRisk.vue?vue&type=script&lang=js&"
import style0 from "./FormRisk.vue?vue&type=style&index=0&id=1c26f8bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c26f8bd",
  null
  
)

export default component.exports